class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('close', () => {
        const drawerContent = this.querySelector('.quick-view__content');
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');
  
        document.dispatchEvent(new CustomEvent('quickview:close'));
      });
    }
}
customElements.define('quick-view-drawer', QuickViewDrawer);
  
class QuickViewButton extends HTMLElement {
    constructor() {
      super();

      this.isInProductBuilder = this.dataset.productBuilder === 'true';

      this.addEventListener('click', async (e) => {
        e.preventDefault();

        const isBuilderMode = this.dataset.productBuilder === 'true';
      
        if (!isBuilderMode) {
          this.toggleQuickViewButton();
          return;
        }
      
        try {
          this.product = await this.getProduct(this.dataset.productUrl);
          const hasVariants = this.product.variants && this.product.variants.length > 1;
      
          if (hasVariants) {
            this.toggleQuickViewButton();
          } else {
            this.addProductToBuilder();
          }
        } catch (error) {
          console.error('Error checking product variants:', error);
        }
      });

      this.addEventListener('keydown', async (event) => {
        event.preventDefault();

        const isEnterKey = event.code.toUpperCase() === 'ENTER';
        const isBuilderMode = this.dataset.productBuilder === 'true';
      
        if (!isBuilderMode) {
          if (isEnterKey) this.toggleQuickViewButton(event);
          return;
        }
      
        try {
          this.product = await this.getProduct(this.dataset.productUrl);
          const hasVariants = this.product.variants && this.product.variants.length > 1;
      
          if (hasVariants) {
            if (isEnterKey) this.toggleQuickViewButton(event);
          } else {
            this.addProductToBuilder();
          }
        } catch (error) {
          console.error('Error checking product variants:', error);
        }
      });

      document.addEventListener('shopify:section:load', (event) => {
        if (this.closest('body.quick-view-open') && event.target.closest('section').querySelector('.quick-view-button') && !event.target.closest('section').querySelector('.popup-wrapper__quick-view.open')) {
          this.closest('body').classList.remove('hidden', 'quick-view-open')
        }
      })
      
      document.addEventListener('quickview:loaded', () => {
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }

        if (this.closest('.image-with-hotspots__hotspot--product')) {
          this.closest('.image-with-hotspots__hotspot--product').querySelector('.image-with-hotspots__dot .loading-overlay__spinner').classList.add('hidden')
          this.closest('.image-with-hotspots__hotspot--product').querySelector('.image-with-hotspots__dot').classList.remove('hidden-dot')
        }

        if (this.isInProductBuilder) {
          document.querySelector('.product-builder-modal[open]')?.hide();
        }
      })
    }

    async getProduct(url) {
      const handle = url.split('/products/')[1];
      if (!handle) return false;
    
      try {
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden')
        }

        const response = await fetch(`/products/${handle}.js`);
        const product = await response.json();
    
        return product;
      } catch (error) {
        console.error('Failed to fetch product JSON:', error);
      } finally {
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.add('hidden')
        }
      }
    }

    addProductToBuilder() {
      if (!this.isInProductBuilder) {
        return;
      }

      const productBuilder = document.getElementById('ProductBuilder');
      const calculations = productBuilder.querySelector('.product-builder__calculations');
      const productCard = document.querySelector(`#ProductBuilderProductCardTemplate-${this.product.id}-${this.dataset.step}`).content.firstElementChild.cloneNode(true);
      const stepButton = productBuilder.querySelector(`.product-builder__modal-opener[data-modal="#${this.closest('.product-builder-modal').id}"]`);
      const target = productBuilder.querySelector(`.product-builder__modal-opener[data-modal="#${this.closest('.product-builder-modal').id}"] + .product-builder__cards`);

      if (target && productCard) {
        target.appendChild(productCard);
        productCard.dataset.variantId = this.product.variants[0].id;

        if (calculations) {
          const price = calculations.querySelector(`.product-builder__calculation[data-step="${this.dataset.step}"] .product-builder__calculation-price`);
          const variantPrice =  parseFloat(productCard.querySelector('.product-builder-product-card__price-value').dataset.price);
          const updatedPrice = parseFloat(price.dataset.price) + variantPrice;

          price.dataset.price = updatedPrice;
          price.innerHTML = this.formatMoney(updatedPrice);

          if (stepButton.classList.contains('product-builder__modal-opener--override-original')) {
            calculations.querySelector('.product-builder__calculation--default').classList.add('product-builder__calculation--irrelevant');
          }

          productBuilder.calculateTotalPrice();
        }

        stepButton.querySelector('.product-builder__step-error').innerHTML = '';
      }

      document.querySelector('.product-builder-modal[open]')?.hide();
    }

    formatMoney(cents) {
      const rate = Shopify.currency?.rate || 1;
      const currency = Shopify.currency?.active || 'USD';
      const convertedCents = cents * rate;

      const formatted = new Intl.NumberFormat(Shopify.locale || 'en', {
        style: 'currency',
        currency: currency
      }).format(convertedCents / 100);
    
      return formatted;
    }

    toggleQuickViewButton(event) {
      if ((event && event.target && event.target.closest('.card-quick-view')) || (event && event.code && event.code.toUpperCase() === 'ENTER')) event.preventDefault()
      
      if (this.querySelector('.loading-overlay__spinner')) {
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden')
      }

      if (this.closest('.image-with-hotspots__hotspot--product')) {
        this.closest('.image-with-hotspots__hotspot--product').querySelector('.image-with-hotspots__dot .loading-overlay__spinner').classList.remove('hidden')
        this.closest('.image-with-hotspots__hotspot--product').querySelector('.image-with-hotspots__dot').classList.add('hidden-dot')
      }

      this.closest('body').classList.add('hidden', 'quick-view-open');

      let drawer = document.querySelector('quick-view-drawer')

      if (drawer) {
        drawer.querySelector('quick-view').setAttribute('data-product-url', `${this.dataset.productVariantUrl}`)
        drawer.querySelector('quick-view').setAttribute('data-product-builder', `${this.isInProductBuilder}`)
        drawer.querySelector('summary').click();
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location = this.dataset.productUrl;
      }
    }
}
customElements.define('quick-view-button', QuickViewButton);

  class QuickView extends HTMLElement {
    constructor() {
      super();

      this.overlay = document.body.querySelector('body > .quick-view-overlay')
      this.quickModal = this.querySelector('.popup-wrapper')
      this.closeButton = this.querySelector('.button-close')

      this.addEventListener('click', (event) => {
        if (!event.target.closest('.popup') || event.target.closest('.button-close')) this.closeQuickView()
      })

      document.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.querySelector('.popup.open')) this.closeQuickView()
      })

      if (this.closest('.collection__grid-container')) {
        document.addEventListener('quickview:open', (e) => {
          this.productUrl = e.detail.productUrl;
        })
      }
    }
  
    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }
  
    handleIntersection(entries, _observer) {
      if (!entries[0].isIntersecting) return;

      const selector = '.quick-view__content';
      const drawerContent = document.querySelector(selector);
      if (!this.closest('.collection__grid-container')) this.productUrl = this.dataset.productUrl;
      this.sectionUrl = `${this.productUrl}&view=quick-view`;
      
      fetch(this.sectionUrl)
        .then(response => response.text())
        .then(responseText => {

          setTimeout(() => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector(selector);
            this.setInnerHTML(drawerContent, productElement.innerHTML);

            if (this.dataset.productBuilder === "true") {
              const template = drawerContent.querySelector('#ProductBuilderQuickViewButtonTemplate');
              const button = template.content.firstElementChild.cloneNode(true);
              const buyButtons = drawerContent.querySelector('.buy-buttons-block .product-form__buttons');
      
              if (buyButtons) {
                const step = document.querySelector('.product-builder-modal[open] quick-view-button').dataset.step;
                const productId = drawerContent.querySelector('.popup-wrapper__quick-view').dataset.productId;

                button.dataset.step = step;
                button.dataset.productCardTemplate = document.querySelector(`#ProductBuilderProductCardTemplate-${productId}-${step}`).innerHTML;

                buyButtons.replaceWith(button);
              }
            }
  
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }, 1);
          // this.overlay = document.body.querySelector('body > .overlay')
          this.overlay?.classList.add('open')
          document.body.classList.add('quick-view-load')

          setTimeout(() => {
            drawerContent.classList.add('hide-cover');
            trapFocus(drawerContent, drawerContent.querySelector('.button-close'))

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            }));
          }, 1);
        })
        .catch(e => {
          console.error(e);
        });
    }
  
    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    closeQuickView() {
      if(this.closest('.card-product')) this.focusElement = this.closest('.card-product').querySelector('.quick-view-button')
      removeTrapFocus(this.focusElement);
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');
      // this.overlay = document.body.querySelector('body > .overlay')
      this.overlay?.classList.remove('open')
      this.closest('body').classList.remove('hidden', 'quick-view-open', 'quick-view-load')
      document.dispatchEvent(new CustomEvent('body:visible'));
      document.dispatchEvent(new CustomEvent('quickview:close'));
      this.closest('details').removeAttribute('open')
    }
  }
customElements.define('quick-view', QuickView);
  